var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("dialogs-base", {
    attrs: {
      show: _setup.dialog,
      "max-width": _vm.maxWidth,
      scrollable: _vm.scrollable,
      "max-height": _vm.maxHeight,
    },
    on: {
      "update:show": function ($event) {
        _setup.dialog = $event
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "v-card",
                { attrs: { loading: _setup.isLoading } },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "grey--text text--darken-3 grey lighten-2 py-1 text-subtitle-2 font-weight-regular",
                    },
                    [
                      _vm._t("title", function () {
                        return [_vm._v(_vm._s(_vm.title))]
                      }),
                      _c("v-spacer"),
                      _vm._t("tools"),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            disabled: _setup.isLoading,
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              _setup.dialog = false
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red lighten-2" } },
                                        [_vm._v("mdi-close")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Fechar")])]
                      ),
                    ],
                    2
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "mt-4" },
                    [_vm._t("form")],
                    2
                  ),
                  _c(
                    "v-card-actions",
                    [
                      !_vm.hideButton && !_setup.isDisabledButton
                        ? _c("small", { staticClass: "text-caption" }, [
                            _vm._v("*Campos obrigatórios"),
                          ])
                        : _vm._e(),
                      _c("v-spacer"),
                      _vm._t("actions"),
                      _vm._t("save", function () {
                        return [
                          !_vm.hideButton
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    color: "primary",
                                    disabled: _setup.isDisabledButton,
                                    loading: _setup.isLoading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _setup.save()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.saveLabel
                                          ? _vm.saveLabel
                                          : _vm.params.id
                                          ? `Atualizar`
                                          : `Cadastrar`
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { small: "", right: "", dark: "" },
                                    },
                                    [_vm._v("mdi-content-save")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }